import { render, staticRenderFns } from "./SurveyExpired.vue?vue&type=template&id=55869994&"
import script from "./SurveyExpired.vue?vue&type=script&lang=js&"
export * from "./SurveyExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports